export const FillStackItem = ({ children }: React.PropsWithChildren) => (
  <div style={{ flex: '1 1 auto' }}>{children}</div>
);
